import axiosInstance, { AxiosError } from 'axios';

import history from './history';

import { API_URL } from '@/config';
import { cookies, storage } from '@/utils';

const config = {
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
};

const unathenticatedInstance = axiosInstance.create(config);
const authenticatedInstance = axiosInstance.create(config);

unathenticatedInstance.interceptors.response.use(
  (response) => response?.data,
  (error: AxiosError) => Promise.reject(error),
);

authenticatedInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error: AxiosError) => {
    if (error.response) {
      if (error.response.status !== 401) {
        return Promise.reject(error);
      }

      return unathenticatedInstance
        .post('/auth/refresh-token', {
          refreshToken: cookies.getRefresh(),
        })
        .then((response) => {
          const result = response as unknown as { accessToken: string };
          cookies.setAccess(result.accessToken);
          if (error.response) {
            error.response.config.headers['Authorization'] = 'Bearer ' + result.accessToken;
            return authenticatedInstance(error.response.config);
          }
        })
        .catch((error) => {
          cookies.clearAccess();
          cookies.clearRefresh();
          storage.clearUser();
          history.push('/');

          if (error?.response?.status === 409) {
            window.location.reload();
            return;
          }

          return Promise.reject(error);
        });
    }
  },
);

export default {
  unauthorized() {
    return unathenticatedInstance;
  },
  authorized() {
    authenticatedInstance.defaults.headers.common.Authorization = `Bearer ${cookies.getAccess()}`;
    return authenticatedInstance;
  },
};
